import NextChapterButton from './NextChapterButton';

export default NextChapterButton;
